import * as Yup from "yup";

export const dataModel = {
  password: "",
  confirmPassword: "",
};

export const validationDataModel = () => {
  return Yup.object().shape({
    password: Yup.string().required("forms.validations.required"),
    confirmPassword: Yup.string()
      .required("forms.validations.required")
      .oneOf([Yup.ref("password"), null], "forms.validations.equalPasswords"),
  });
};

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
